// [2026-03-09] GDPR cookie consent: Dynamic GA/GTM loader
// Scripts are injected only after explicit user consent.
// [2026-04-09] Added Meta Pixel — prod only (skipped on localhost + non-PROD environments)

// [2026-07-13] analytics-tag: Updated GA4 measurement ID to new property (G-YC6J86FYJT)
const GA_ID = "G-YC6J86FYJT";
const GTM_ID = "GTM-KLMK63XS";
const META_PIXEL_ID = "826594110480722";

let loaded = false;

/** Returns true if running on localhost / dev */
function isLocalhost(): boolean {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1";
}

/** Inject Google Analytics (gtag.js) */
function loadGA(): void {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", GA_ID);
}

/** Inject Meta Pixel */
function loadMetaPixel(): void {
  const env = process.env.REACT_APP_ENVIRONMENT;
  // Only fire when REACT_APP_ENVIRONMENT is explicitly "production"
  if (env !== "production") return;

  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  (window as any).fbq("init", META_PIXEL_ID);
  (window as any).fbq("track", "PageView");
}

/** Inject Google Tag Manager */
function loadGTM(): void {
  (function (w: any, d: Document, s: string, l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(window, document, "script", "dataLayer", GTM_ID);
}

/**
 * Load GA + GTM scripts dynamically.
 * Skipped on localhost and if already loaded.
 */
export function loadAnalytics(): void {
  if (loaded || isLocalhost()) return;
  loaded = true;
  loadGA();
  loadGTM();
  loadMetaPixel();
}
